<span class="text-lg font-bold text-dark">{{ title() }}</span>
<hr />
<table class="w-full table-striped">
  <thead>
    <tr>
      <th class="p-2"></th>
      <th class="p-2"></th>
    </tr>
  </thead>
  <tbody>
    @for (item of entries(); track $index) {
    <tr>
      <td class="p-2">
        {{ translationPrefix() + "." + item.key.toUpperCase() | translate }}
      </td>
      <td class="p-2" style="width: 100%;">
        <div style="width: 100%; text-align: right;">
          {{ item.value ?? "-" }}
        </div>
      </td>
    </tr>
    }
  </tbody>
</table>